<hpf-role-permission-form
	[rolePermission]="rolePermission"
	[loading]="rolePermission.isNew()"
	(update)="onUpdate()"
	(delete)="onDelete()"
></hpf-role-permission-form>
